// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".properties-list-grid[data-v-30fdc10f]{height:calc(100vh - 116px) !important}", ""]);
// Exports
module.exports = exports;
